// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"664":"reactPlayerPreview","678":"47bf8baf"}[chunkId] + "." + {"664":"c73ca6750d52963a","678":"489f9f2cab8e7c0b"}[chunkId] + ".js";
};